import React from 'react';
import { Link } from 'react-router-dom';
import {
  BuildingOffice2Icon,
  ShieldCheckIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline';

export default function AdminTenantsHub() {
  return (
    <div className="p-8 max-w-4xl mx-auto">

      <div className="mb-8">
        <div className="text-xs text-gray-500 mb-1">Administration</div>
        <h1 className="text-xl font-bold text-gray-100">Tenants</h1>
        <p className="text-sm text-gray-500 mt-1">
          Manage M365 tenants and their BlackPoint Cyber MDR tenant mapping
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-6">

        {/* M365 Tenants card */}
        <Link
          to="/admin/tenants/m365"
          className="bg-gray-900 border border-gray-800 hover:border-blue-500/40 rounded-xl p-6 flex flex-col transition-colors group"
        >
          <div className="flex items-start gap-3 mb-5">
            <div className="p-2.5 bg-blue-600/15 rounded-lg flex-shrink-0">
              <BuildingOffice2Icon className="h-6 w-6 text-blue-400" />
            </div>
            <div className="flex-1">
              <h2 className="text-base font-semibold text-gray-100">M365 Tenants</h2>
              <p className="text-xs text-gray-500 mt-0.5">
                Onboard, edit, activate, and manage Microsoft 365 tenants
              </p>
            </div>
          </div>

          <div className="mt-auto flex items-center text-sm font-medium text-blue-400 group-hover:text-blue-300">
            Manage M365 tenants
            <ArrowRightIcon className="h-4 w-4 ml-1.5" />
          </div>
        </Link>

        {/* BPC Tenants card */}
        <Link
          to="/admin/tenants/bpc"
          className="bg-gray-900 border border-gray-800 hover:border-emerald-500/40 rounded-xl p-6 flex flex-col transition-colors group"
        >
          <div className="flex items-start gap-3 mb-5">
            <div className="p-2.5 bg-emerald-600/15 rounded-lg flex-shrink-0">
              <ShieldCheckIcon className="h-6 w-6 text-emerald-400" />
            </div>
            <div className="flex-1">
              <h2 className="text-base font-semibold text-gray-100">BlackPoint Cyber MDR Tenants</h2>
              <p className="text-xs text-gray-500 mt-0.5">
                Manage BPC accounts and map them to M365 tenants for device inventory comparison
              </p>
            </div>
          </div>

          <div className="mt-auto flex items-center text-sm font-medium text-emerald-400 group-hover:text-emerald-300">
            Manage BPC tenants
            <ArrowRightIcon className="h-4 w-4 ml-1.5" />
          </div>
        </Link>
      </div>
    </div>
  );
}
